<template>
  <div style="width: max-content;">
    <v-alert
      border="top"
      colored-border
      prominent
      type="warning"
      color="#cf1515"
      icon="mdi-alert-outline"
      elevation="4"
    >
      {{message || 'Área destinada para usuários administradores!' | translate('NoAdmBanner')}}
    </v-alert>
  </div>
</template>
<script>

export default {
    name: 'NoAdmBanner',
    props: ['message'],
    data() {
        return {}
    },
    computed: {
    },
    methods: {
    }

}
</script>